import script from "./LoginPage2.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPage2.vue?vue&type=script&setup=true&lang=js"

import "./LoginPage2.vue?vue&type=style&index=0&id=0a3022cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a3022cb"]])

export default __exports__